exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toast---2L2-i {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: fixed;\n  bottom: 77px;\n  left: 0;\n  width: 100%;\n  visibility: visible;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-top: 15px;\n  padding-bottom: 15px;\n  opacity: 0;\n  -webkit-animation: fadeIn---s7cFb 7s;\n          animation: fadeIn---s7cFb 7s;\n  font-size: 17px;\n  z-index: 2147483647; }\n\n.message---2WI7- {\n  color: white; }\n\n@-webkit-keyframes fadeIn---s7cFb {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n\n@keyframes fadeIn---s7cFb {\n  0% {\n    opacity: 0; }\n  25% {\n    opacity: 1; }\n  75% {\n    opacity: 1; }\n  100% {\n    opacity: 0; } }\n", ""]);

// exports
exports.locals = {
	"toast": "toast---2L2-i",
	"fadeIn": "fadeIn---s7cFb",
	"message": "message---2WI7-"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/toast/index.scss
// module id = 720
// module chunks = 3